import { useFlaggedCount } from '@task-manager/entities/tasks';
import { Badge } from '@/shared/ui';

/**
 * Numeric badge over the topbar drawer trigger. Subscribes to
 * `trpc.tasks.flaggedCount` so it updates without polling whenever a task
 * mutation runs anywhere in the app (every mutation hook invalidates this
 * query on settle).
 *
 * Renders nothing when the count is 0 — keeps the topbar clean.
 *
 * v1: uses `variant="error"` (red) for any non-zero count. Legacy split
 * red (Urgent ≥ 10) vs yellow (Attention ≥ 5); the server currently
 * returns a single total via `flaggedCount`. TODO(v2): return a
 * breakdown `{ urgent, attention }` and pick the variant from that.
 */
export const TaskCountBadge = () => {
  const { data } = useFlaggedCount();
  if (!data || data === 0) return null;
  return <Badge variant="error">{data}</Badge>;
};
